import common from '@/common'
import i18n from '@/lang'

export default {
    INIT_DATA(state) {
        if (this.CHANGE_LANG) {
            this.CHANGE_LANG(state)
        } else {
            this.commit('dataMap/CHANGE_LANG')
        }
        const userCompanyInfo = JSON.parse(localStorage.getItem('userCompanyInfo') || '{}')
        state.helperTypeMap = [...state.allHelperTypeMap]
        state.helperTypeMap = common.getHelperTypeMap(state.allHelperTypeMap, userCompanyInfo.type === 'agency' ? userCompanyInfo.countryAreaId : '')
        state.languageMap = userCompanyInfo.id === 4744 ? [{
            name: 'En',
            value: 'en_SG',
        }, {
            name: '繁體中文',
            value: 'zh-Hant-TW',
        }] : [{
            name: 'En',
            value: 'en_SG',
        }, {
            name: 'zh_CN',
            value: 'zh_CN',
        }]
    },
    SET_SUPPORT_COUNTRY_MAP(state, payload) {
        state.supportCountryMap = payload
    },
    SET_EMPLOYER_SUPPORT_COUNTRY_MAP(state, payload) {
        state.supportEmployerCountryMap = payload
    },
    SET_HELPER_CREATOR_MAP(state, payload) {
        state.helperCreatorMap = payload
    },
    SET_INTERVIEW_CREATOR_MAP(state, payload) {
        state.interviewCreatorMap = payload
    },
    SET_MANAGER_MAP(state, payload) {
        state.managerMap = payload
    },
    SET_COMMON_DICTIONARY(state, payload) {
        state.commonDictionary = formatCommonDic(payload)
    },
    SET_DICTIONARY(state, payload) {
        Object.assign(state.dictionary, payload)
    },
    CHANGE_LANG(state) {
        state.contractStatusDescListMap = [
            {
                label: i18n.t('before_the_agency_submits_the_employer'),
                value: 2,
            },
            {
                label: i18n.t('on_confirmation_of_FDW_through_bio_data'),
                value: 1,
            },
            {
                label: i18n.t('after_IPA_approved'),
                value: 15,
            },
            {
                label: i18n.t('when_the_FDW_reports_for_work_duty'),
                value: 10,
            },
            {
                label: i18n.t('full_sum_payable_upon_handover'),
                value: 999,
            },
        ]

        state.genderMap = [{
            name: i18n.t('male'),
            value: 1,
        }, {
            name: i18n.t('female'),
            value: 0,
        }]

        state.excludeAnyOtherRemarkOptionalMap = [
            { label: i18n.t('no_tattoo'), value: 'She has tattoo' },
            { label: i18n.t('not_short_sighted'), value: 'She is short sighted' },
            { label: i18n.t('not_scared_of_small_dog'), value: 'She is scared of small dog' },
            { label: i18n.t('not_scared_of_big_dog'), value: 'She is scared of big dog' },
            { label: i18n.t('not_scared_of_cat'), value: 'She is scared of cat' },
            { label: i18n.t('not_scared_of_dog'), value: 'She is scared of dog' },
        ]

        state.allHelperTypeMap = [{
            name: i18n.t('new'),
            code: 'New',
            value: 0,
        }, {
            name: i18n.t('transfer'),
            code: 'Transfer',
            value: 3,
        }, {
            name: 'Ex-Malaysia',
            code: 'Ex-Malaysia',
            value: 7,
        }, {
            name: i18n.t('ex_singapore'),
            code: 'EX-Singapore',
            value: 1,
        }, {
            name: i18n.t('ex_hong_kong'),
            code: 'Ex-Hong Kong',
            value: 4,
        }, {
            name: i18n.t('ex_macao'),
            code: 'Ex-Macao',
            value: 12,
        }, {
            name: i18n.t('ex_taiwan'),
            code: 'Ex-Taiwan',
            value: 5,
        }, {
            name: i18n.t('ex_china'),
            code: 'EX-China',
            value: 6,
        }, {
            name: 'Ex-Saudi Arabia',
            code: 'Ex-Saudi Arabia',
            value: 11,
        }, {
            name: 'Ex-UAE', // 阿拉伯联合酋长国 United Arab Emirates
            code: 'Ex-UAE',
            value: 10,
        }, {
            name: 'Ex-Oman',
            code: 'Ex-Oman',
            value: 8,
        }, {
            name: 'Ex-Qatar',
            code: 'Ex-Qatar',
            value: 9,
        }, {
            name: i18n.t('ex_abroad'),
            code: 'Ex-Abroad',
            value: 2,
        }]

        state.haveChildMap = [{
            name: i18n.t('yes'),
            value: 1,
        }, {
            name: i18n.t('no'),
            value: 0,
        }]

        state.skillExperienceMap = [{
            name: i18n.t('experienced'),
            value: 100,
        }, {
            name: i18n.t('no_experience'),
            value: 0,
        }]
        state.restDayMap = [{
            name: 1,
            value: 1,
        }, {
            name: 2,
            value: 2,
        }, {
            name: 3,
            value: 3,
        }, {
            name: i18n.t('weekly'),
            value: 4,
        }]

        state.completedContractMap = [{
            name: i18n.t('all_contracts_completed'),
            value: -1,
        }, {
            name: 'At Least 1',
            value: 1,
        }, {
            name: 'At Least 2',
            value: 2,
        }, {
            name: 'At Least 3',
            value: 3,
        }, {
            name: 'At Least 4',
            value: 4,
        }, {
            name: 'At Least 5',
            value: 5,
        }, {
            name: 'At Least 6',
            value: 6,
        }, {
            name: 'At Least 7',
            value: 7,
        }, {
            name: 'At Least 8',
            value: 8,
        }, {
            name: 'At Least 9',
            value: 9,
        }, {
            name: i18n.t('10_and_above'),
            value: 10,
        }]

        state.offReasonMap = [
            i18n.t('Completion of Contract'),
            i18n.t('Employer doesn\'t need a helper anymore'),
            i18n.t('Employer unable to maintain a helper anymore'),
            i18n.t('Employer went back to home country / went to other country/region'),
            i18n.t('Employer decided to change a helper'),
            i18n.t('No privacy in sleeping area'),
            i18n.t('Working in more than 1  house'),
            i18n.t('Workscope different from job offer'),
            i18n.t('Unable to get along with another helper'),
            i18n.t('Personal emergency back at home'),
            i18n.t('Resigned due to unfair treatment'),
            i18n.t('Resigned due to too much workload'),
        ]

        state.onlineStatusMap = [{
            name: i18n.t('offline'),
            value: 0,
        }, {
            name: i18n.t('pending_review'),
            value: 1,
        }, {
            name: i18n.t('online'),
            value: 2,
        }]

        state.yesNoMap = [{
            name: i18n.t('yes'),
            value: 1,
        }, {
            name: i18n.t('no'),
            value: 0,
        }]

        state.yesNoBoolMap = [{
            name: i18n.t('yes'),
            value: true,
        }, {
            name: i18n.t('no'),
            value: false,
        }]
        state.enableMap = [{
            name: i18n.t('enable'),
            value: 1,
        }, {
            name: i18n.t('disable'),
            value: 0,
        }]

        state.enableBoolMap = [{
            name: i18n.t('enable'),
            value: true,
        }, {
            name: i18n.t('disable'),
            value: false,
        }]

        state.haveOrNotMap = [{
            name: i18n.t('have'),
            value: 1,
        }, {
            name: i18n.t('have_not'),
            value: 0,
        }]

        state.haveOrNotBoolMap = [{
            name: i18n.t('have'),
            value: true,
        }, {
            name: i18n.t('have_not'),
            value: false,
        }]

        state.exclusiveOrNotMap = [{
            name: 'Non-Exclusive',
            value: 0,
        }, {
            name: 'Exclusive',
            value: 1,
        }]

        state.privateRoomMap = [
            i18n.t('separate_room'),
            i18n.t('share_a_room_with_1_child'),
            i18n.t('share_a_room_with_2_children'),
            i18n.t('share_a_room_with_3_children'),
            i18n.t('share_a_room_with_another_helper'),
            i18n.t('share_a_room_with_ah_ma'),
            i18n.t('partition_room'),
        ]

        state.holidayOffMap = [{
            name: i18n.t('yes'),
            value: 1,
        }, {
            name: i18n.t('no'),
            value: 0,
        }, {
            name: i18n.t('negotiable'),
            value: 2,
        }]

        state.havePetsMap = [{
            name: i18n.t('no'),
            value: 0,
        }, {
            name: i18n.t('yes'),
            value: 1,
        }]

        state.interviewTypeMap = [
            i18n.t('phone'),
            i18n.t('peanut_chat_video'),
            i18n.t('in_person'),
            i18n.t('video_call_via_WhatsApp_Messenger'),
        ]

        state.birthPlaceList = [
            i18n.t('Philippines'),
            i18n.t('Indonesian'),
            i18n.t('Myanmar'),
            i18n.t('India'),
        ]

        state.restDayGrantedOnListMap = [
            i18n.t('sunday'),
            i18n.t('monday'),
            i18n.t('tuesday'),
            i18n.t('wednesday'),
            i18n.t('thursday'),
            i18n.t('friday'),
            i18n.t('saturday'),
            i18n.t('weekend'),
            i18n.t('weekday'),
        ]

        state.contractEmploymentStatusMap = [{
            name: i18n.t('ongoing'),
            value: 1,
        }, {
            name: i18n.t('expiring'),
            value: 2,
        }, {
            name: i18n.t('expired'),
            value: 3,
        }, {
            name: i18n.t('renewing'),
            value: 4,
        }, {
            name: i18n.t('renewed'),
            value: 5,
        }, {
            name: i18n.t('to_be_terminate'),
            value: 6,
        }, {
            name: i18n.t('terminated'),
            value: 7,
        }]

        state.helperOutcomeMap = [{
            name: i18n.t('helper_will_be_has_been_repatriated'),
            value: 1,
        }, {
            name: i18n.t('helper_will_be_has_been_transferred'),
            value: 2,
        }, {
            name: i18n.t('helpers_status_is_currently_unknown'),
            value: 3,
        }]

        state.titleMap = [{
            name: i18n.t('Mr'),
            value: 'Mr',
        }, {
            name: i18n.t('Ms'),
            value: 'Ms',
        }, {
            name: i18n.t('Mrs'),
            value: 'Mrs',
        }]

        state.petsTypeList = [
            i18n.t('small_dog'),
            i18n.t('big_dog'),
            i18n.t('cat'),
            i18n.t('fish'),
            i18n.t('rabbit'),
            i18n.t('parrot'),
            i18n.t('bird'),
            i18n.t('turtle'),
            i18n.t('lizard'),
        ]

        state.enquirySourceMap = [{
            name: 'Maid Island',
            value: 1,
        }, {
            name: i18n.t('official_website'),
            value: 2,
        }, {
            name: 'Bestmaid',
            value: 3,
        }, {
            name: 'Netmaid',
            value: 4,
        }]

        state.contractCollectTypeMap = [{
            name: 'Employer Info',
            value: 1,
            route: 'ContractCollectEmployerInfo',
        }, {
            name: 'Sponsor1 Info',
            value: 2,
            route: 'ContractCollectSponsorJointInfo',
        }, {
            name: 'Sponsor2 Info',
            value: 3,
            route: 'ContractCollectSponsorJointInfo',
        }, {
            name: 'Joint Info',
            value: 4,
            route: 'ContractCollectSponsorJointInfo',
        }, {
            name: 'Job Offer Info',
            value: 5,
            route: 'ContractCollectJobOffer',
        }]

        state.helperTimelineEventMap = [{
            value: 1,
            name: i18n.t('register'),
        }, {
            value: 2,
            name: i18n.t('pending_interview'),
        }, {
            value: 3,
            name: i18n.t('pending_incomplete_bio'),
        }, {
            value: 4,
            name: i18n.t('online_available'),
        }, {
            value: 5,
            name: i18n.t('interview'),
        }, {
            value: 6,
            name: i18n.t('check_in'),
        }, {
            value: 7,
            name: i18n.t('check_out'),
        }, {
            value: 8,
            name: i18n.t('contract'),
        }, {
            value: 9,
            name: i18n.t('tracking_record'),
        }, {
            value: 10,
            name: i18n.t('offline'),
        }, {
            value: 11,
            name: i18n.t('pending_temp_U_A'),
        }, {
            value: 12,
            name: i18n.t('pending_training'),
        }, {
            value: 13,
            name: i18n.t('create'),
        }, {
            value: 14,
            name: 'Edit Target Country/Region',
        }]

        state.interviewAvailabilityMap = [{
            name: i18n.t('temporary_not_available'),
            value: 2,
        }, {
            name: i18n.t('available'),
            value: 1,
        }]

        state.interviewAvailabilityFilterMap = [{
            name: i18n.t('temporary_not_available'),
            value: 2,
        }, {
            name: i18n.t('hide_temporary_unavailable'),
            value: 3,
        }]

        state.contractTypeMap = [{
            name: i18n.t('sales_contract'),
            value: 0,
        }, {
            name: i18n.t('processing_service_contract'),
            value: 1,
        }]

        state.offDayArrangementMap = [{
            name: i18n.t('willing_to_stay_in_on_off_days'),
            value: 1,
        }, {
            name: i18n.t('unwilling_to_stay_in_on_off_days'),
            value: 0,
        }]

        state.hkResidentialTypeMap = [{
            name: i18n.t('flat'),
            value: 1,
        }, {
            name: i18n.t('house'),
            value: 2,
        }]

        state.hkHelperFacilitiesMap = [{
            name:  i18n.t('light_and_water_supply'),
            value: 1,
        }, {
            name:  i18n.t('toilet_and_bathing_facilities'),
            value: 2,
        }, {
            name:  i18n.t('bed'),
            value: 3,
        }, {
            name:  i18n.t('blankets_or_quilt'),
            value: 4,
        }, {
            name:  i18n.t('pillows'),
            value: 5,
        }, {
            name:  i18n.t('wardrobe'),
            value: 6,
        }, {
            name:  i18n.t('refrigerator'),
            value: 7,
        }, {
            name:  i18n.t('desk'),
            value: 8,
        }]
    }
}

function formatCommonDic(dic) {
    if (dic.diet) {
        dic.diet = dic.diet.map(item => {
            if (item.name) {
                item.name = i18n.t(item.value)
                return item
            }
            return {
                name: i18n.t(item),
                value: item,
            }
        })
    }
    if (dic.foodHandling) {
        dic.foodHandling = dic.foodHandling.map(item => {
            if (item.name) {
                item.name = i18n.t(item.value)
                return item
            }
            return {
                name: i18n.t(item),
                value: item,
            }
        })
    }
    return dic
}
